var styles = {"list-wrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","listWrapper":"styles_list-wrapper__1t7xO flex flex-auto flex-column","message-list":"styles_message-list__dkon3 block flex-auto justify-start m0 px1","messageList":"styles_message-list__dkon3 block flex-auto justify-start m0 px1","flat":"styles_flat__2n2fx px2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
